var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{domProps:{"innerHTML":_vm._s(_vm.dealWithValue)}})
}
var staticRenderFns = []

export { render, staticRenderFns }